// extracted by mini-css-extract-plugin
var _1 = "RequestProfileTabRating-modulecontainer__elxKw";
export { _1 as "container" }
